import css from './DeliveryTable.css'
import { on, ready, query } from '../../lib/dom.js'
import { ajaxPost, fireEvent } from '../../lib/jsfunc.js'

ready(function () {
  var deliveryTable = query('.DeliveryTable');
  
  if(deliveryTable){
    var deliveryMethod = query(deliveryTable, 'input.deliveryMethod');
    if(deliveryMethod){
      fireEvent(deliveryMethod, 'change');
    }
  
    on('change', 'input.deliveryAccNr', function(event) {
      var buttonC = query('.Button.continue');
      
      event.preventDefault();
      if(event.target.value == ''){
        if(!buttonC.matches('.disabled')){
          buttonC.classList.add('disabled');
          event.target.classList.add('error');
          buttonC.setAttribute('disabled','disabled');
        }
      }else{
        if(buttonC.matches('.disabled')){
          buttonC.classList.remove('disabled');
          event.target.classList.remove('error');
          buttonC.removeAttribute('disabled');
        }
      }
    })

    var form = query('.shop.delivery form');
    if(form){
      on('click', 'input[type="radio"]', function(event) {
        var table = event.target.closest('.DeliveryTable');
        var deliveryMethod = query(table, 'input.deliveryMethod[type="radio"]:checked');
        var deliveryTerms  = query(table, 'input.deliveryTerms[type="radio"]:checked');
        var deliveryAccNr  = query(table, 'input.deliveryAccNr');
        var deliveryAccNrPattern  = query(table, 'input.deliveryAccNrPattern[type="hidden"]');
        var data = {
          'deliveryMethod': deliveryMethod ? deliveryMethod.value : undefined,
          'deliveryTerms': deliveryTerms ? deliveryTerms.value : undefined,
          'deliveryAccNrPattern': deliveryAccNrPattern ? deliveryAccNrPattern.value : undefined,
          'deliveryAccNr': deliveryAccNr.value,
        };
        console.log('CLICK ');
        
        console.log(table.getAttribute('data-url'));
        
        
        ajaxPost(table.getAttribute('data-url'), data,
          function (request){
            var buttonC = query('.Button.continue');
            var response = JSON.parse(request.responseText);
            var table_delivery  = response['table_delivery'];

            var deliveryTable = query('.DeliveryTable');
            if(deliveryTable){
              deliveryTable.outerHTML = table_delivery;
              var disabled = response['disabled'];
              if(buttonC.matches('.disabled')){
                if(!disabled){
                  buttonC.classList.remove('disabled');
                  buttonC.setAttribute('disabled','');
                }
              }else{
                if(disabled){
                  buttonC.classList.add('disabled');
                  buttonC.setAttribute('disabled','disabled');
                }
              }
            }
          }
        );
      })
    }
  }
})